'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildResponderKeyFromRequest = exports.buildResponderKeyFromResponder = exports.buildResponderKey = undefined;

var _agentTypeToSenderType = require('conversations-schema/operators/agent-type/agentTypeToSenderType');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _immutable = require('immutable');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildResponderKey = exports.buildResponderKey = function buildResponderKey(_ref) {
  var senderId = _ref.senderId,
      senderType = _ref.senderType;

  (0, _invariant2.default)(senderId && senderType, 'Responder keys must be set with valid ID and type. Received %s, %s', senderId, senderType);
  return (0, _immutable.Map)({
    senderId: String(senderId),
    senderType: senderType
  });
};

var buildResponderKeyFromResponder = exports.buildResponderKeyFromResponder = function buildResponderKeyFromResponder(responder) {
  var senderId = (0, _responderGetters.getUserId)(responder);
  var agentType = (0, _responderGetters.getAgentType)(responder);
  var senderType = agentType ? (0, _agentTypeToSenderType.agentTypeToSenderType)(agentType, true) : (0, _responderGetters.getIsBot)(responder) ? _senderTypes.BOT : _senderTypes.AGENT;
  return buildResponderKey({ senderId: senderId, senderType: senderType });
};

var buildResponderKeyFromRequest = exports.buildResponderKeyFromRequest = function buildResponderKeyFromRequest(requestArgs) {
  var senderId = requestArgs.senderId,
      agentType = requestArgs.agentType;

  var senderType = (0, _agentTypeToSenderType.agentTypeToSenderType)(agentType, true);
  return buildResponderKey({ senderId: senderId, senderType: senderType });
};